<template>
  <div class="force-wrapper">
    <!-- 正常模式 -->
    <div ref="graphContainer" class="force-graph-container"></div>
    <!-- 右下角按钮 -->
    <div class="fullscreen-btn" @click="enterFullscreen">⛶</div>
    <!-- 全屏模式 -->
    <teleport to="body">
      <div v-if="isFullscreen" class="fullscreen-overlay">
        <div ref="fullscreenContainer" class="fullscreen-graph"></div>
        <!-- 关闭按钮 -->
        <div class="close-btn" @click="exitFullscreen">✕</div>
      </div>
    </teleport>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
  import ForceGraph3D from '3d-force-graph';
  import jsonDatas from './blocks.json';

  const graphContainer = ref(null);
  const fullscreenContainer = ref(null);

  let Graph = null;
  let resizeObserver = null;

  const isFullscreen = ref(false);

  // 初始化函数（复用）
  const initGraph = (el, width, height) => {
    return new ForceGraph3D(el)
      .graphData(jsonDatas)
      .width(width)
      .height(height)
      .nodeAutoColorBy('user')
      .nodeLabel(node => `${node.user}: ${node.description}`)
      .backgroundColor('#000d1a')
      .showNavInfo(false);
  };


  // 👉 进入全屏
  const enterFullscreen = async () => {
    isFullscreen.value = true;

    await nextTick();

    // 销毁旧实例
    Graph && Graph._destructor();

    const width = window.innerWidth;
    const height = window.innerHeight;

    Graph = initGraph(fullscreenContainer.value, width, height);
  };

  // 👉 退出全屏
  const exitFullscreen = async () => {
    isFullscreen.value = false;

    await nextTick();

    // 销毁全屏实例
    Graph && Graph._destructor();

    const width = graphContainer.value.clientWidth;
    const height = graphContainer.value.clientHeight || 240;

    Graph = initGraph(graphContainer.value, width, height);
  };

  onMounted(() => {
    const width = graphContainer.value.clientWidth;
    const height = graphContainer.value.clientHeight || 240;

    Graph = initGraph(graphContainer.value, width, height);

    resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        Graph && Graph.width(width).height(height || 240);
      }
    });

    resizeObserver.observe(graphContainer.value);
  });

  onBeforeUnmount(() => {
    resizeObserver && resizeObserver.disconnect();
    Graph && Graph._destructor();
  });
</script>

<style scoped>
  .force-wrapper {
    position: relative;
  }

  /* 原始图 */
  .force-graph-container {
    width: 100%;
    height: 240px;
    border-radius: 22px;
    overflow: hidden;
  }

  /* 右下角按钮 */
  .fullscreen-btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 6px;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 14px;
    z-index: 10;
  }

  /* 全屏遮罩 */
  .fullscreen-overlay {
    position: fixed;
    inset: 0;
    background: #000d1a;
    z-index: 9999;
  }

  /* 全屏 graph */
  .fullscreen-graph {
    width: 100%;
    height: 100%;
  }

  /* 关闭按钮 */
  .close-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    color: white;
    font-size: 22px;
    cursor: pointer;
    z-index: 10;
  }
</style>